import numeral from "numeral";

Vue.filter('number', function (value) {
    let numeralFormat = "0,0.00";
    if (!value) return '0'
    return numeral(value).format(numeralFormat)
})
